module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IiYjMjMyOyYjMTkxOyYjMTQ4OyYjMjI5OyYjMTU1OyYjMTU4OyI+CjxwYXRoIGlkPSJSZWN0YW5nbGUgMzQ2MjQzODEiIGQ9Ik02Ljg4MzMgMy40NDhMMTAuOTM1NCA3LjUwMDA2TDYuODgzMyAxMS41NTIxIiBzdHJva2U9IiNFOTZGMkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/returnPro.svg
// module id = 1ee4
// module chunks = 0